import React from "react";
import Navbar from "../components/Navbar";
import "../styles/global.css";
import Footer from "../components/Footer";
import Newsletter from "../components/Newsletter";
import { Helmet } from "react-helmet-async";

const NewsletterPage = () => {
  
  return (
    <>
      <Helmet>
        <title>Newsflash | TimeWatch Infocom</title>
        <meta
          name="description"
          content="Stay updated with the latest news, product launches, and industry insights from TimeWatch Infocom. As a leader in biometric solutions, access control systems, and smart security technologies, we bring you the latest trends in time attendance systems, entrance automation, and parking management. Our Newsflash page highlights company achievements, new certifications, technological innovations, and more. Stay informed on how TimeWatch Infocom continues to innovate and provide reliable security solutions for businesses, organizations, and industries."
        />
        <link
          rel="canonical"
          href="https://www.timewatchindia.com/newsflash"
        />
      </Helmet>
      <header className="navbar">
        <Navbar />
      </header>

      <div className="content-container">
        <section className="newsletter">
          <Newsletter />
        </section>
      </div>

      <footer className="footer">
        <Footer />
      </footer>
    </>
  );
};

export default NewsletterPage;
